// extracted by mini-css-extract-plugin
module.exports = {"SideDrawer":"SideDrawer_SideDrawer__3vlVa","Open":"SideDrawer_Open__58SM_","Close":"SideDrawer_Close__2dPpr","Logo":"SideDrawer_Logo__1jQTD"};